import axiosInstance from "components/utils/axiosInstance";
const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;
export const getAllUsers = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}/Users/AllUsers`);

  return response.data;
};

export const getAllAdmins = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}/Users/GetParentUsers`);

  return response.data;
};

export const addUser = async (data) => {
  const response = await axiosInstance.post(`${API_BASE_URL}/Users/SaveUser`, data);
  return response.data;
};
///////////////FETCH FILTERS//////////////
export const getOutletFilters = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}/filters`);
  const data = response.data;
  return {
    tiers: Object.entries(data.tiers).map(([id, name]) => ({ id, name })),
    categories: Object.entries(data.categories).map(([id, name]) => ({
      id,
      name,
    })),
    countries: Object.entries(data.countries).map(([id, name]) => ({
      id,
      name,
    })),
    regions: Object.entries(data.regions).map(([id, name]) => ({ id, name })),
    counties: Object.entries(data.counties).map(([id, name]) => ({ id, name })),
    fulfillmentCenters: Object.entries(data.fulfillmentCenters).map(
      ([id, name]) => ({ id, name })
    ),
    fulfillmentDistricts: Object.entries(data.fulfillmentDistricts).map(
      ([id, name]) => ({ id, name })
    ),
    tradeChannels: Object.entries(data.tradeChannels).map(([id, name]) => ({
      id,
      name,
    })),
    subTradeChannels: Object.entries(data.subTradeChannels).map(
      ([id, name]) => ({ id, name })
    ),
  };
};

export const addCustomer = async (campaignId,userId, data) => {
  const response= await axiosInstance.post(
    `${API_BASE_URL}/outlets/registerCampaignOutlet?campaignId=${campaignId}&userId=${userId}`,
    data
  );
  return response.data;
};

////////////////////////GET USER'S CAMPSIGNS////////////////////////////////
export const getUsersCampaigns = async (userId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Users/GetUsersCampaign?userId=${userId}`
  );
  return response.data;
};

// POST user-campaign assignment
export const saveUserCampaign = async ({ usersId, campaignId }) => {
  const response = await axiosInstance.post(`${API_BASE_URL}/Users/SaveUsersCampaign`, {
    usersId,
    campaignId,
  });
  return response.data;
};

// POST user-campaign assignment
export const saveUserBrandCampaign = async ({ usersId, brandCampaignId }) => {
  const response = await axiosInstance.post(`${API_BASE_URL}/Users/SaveUsersBrand`, {
    usersId,
    brandCampaignId,
  });
  return response.data;
};


// DELETE user-campaign assignment

export const deleteUserCampaign = async (usersCampaignId) => {
  const response = await axiosInstance.delete(
    `${API_BASE_URL}/Users/DeleteUsersCampaign?usersCampaignId=${usersCampaignId}`
  );
  return response.data;
};

export const sendMessage = async ({ phoneNumber, content }) => {
  const payload = {
    message: {
      content,
      isSingleMessage: 1,
      phoneNumber,
    },
    outletFilter: {},
  };

  const { data } = await axiosInstance.post(`${API_BASE_URL}/Message`, payload);
  return data;
};


export const getUserCampaigStats = async (userId, campaignId, page=1, size=100) =>{
  const response = await axiosInstance.get(`${API_BASE_URL}/Users/user-campaign-stats?userId=${userId}&campaignId=${campaignId}&page=${page}&pageSize=${size}`)
  return response.data;
}

export const deleteUser = async ({ userId, reason, token }) => {
  const response = await axiosInstance.delete(`${API_BASE_URL}/Users/${userId}`, {
    params: { reason },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getUsersBrands = async (userId) => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}/Users/userBrand?userId=${userId}`
  );
  return response.data;
};

export const deleteUserBrand = async (usersBrandId) => {
  const response = await axiosInstance.delete(
    `${API_BASE_URL}/Users/RemoveUsersBrand/${usersBrandId}`
  );
  return response.data;
};